export default __webpack_public_path__ + "static/1762-8004a1bc2b9cffec0fb99adf09d77b46.gif";